var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgChromeExtension = function SvgChromeExtension(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.7 3.5C7.7 1.567 9.267 0 11.2 0C13.133 0 14.7 1.567 14.7 3.5V5.6H16.1C18.057 5.6 19.0354 5.6 19.8073 5.91971C20.8364 6.34598 21.654 7.16361 22.0803 8.19273C22.4 8.96457 22.4 9.94305 22.4 11.9H24.5C26.433 11.9 28 13.467 28 15.4C28 17.333 26.433 18.9 24.5 18.9H22.4V21.28C22.4 23.6322 22.4 24.8083 21.9422 25.7068C21.5396 26.497 20.897 27.1396 20.1068 27.5422C19.2083 28 18.0322 28 15.68 28H14.7V25.55C14.7 23.8103 13.2897 22.4 11.55 22.4C9.8103 22.4 8.4 23.8103 8.4 25.55V28H6.72C4.36778 28 3.19167 28 2.29324 27.5422C1.50296 27.1396 0.860441 26.497 0.457773 25.7068C0 24.8083 0 23.6322 0 21.28V18.9H2.1C4.033 18.9 5.6 17.333 5.6 15.4C5.6 13.467 4.033 11.9 2.1 11.9H0C0 9.94305 0 8.96457 0.319706 8.19273C0.74598 7.16361 1.56361 6.34598 2.59273 5.91971C3.36457 5.6 4.34305 5.6 6.3 5.6H7.7V3.5Z",
    fill: "#333333"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChromeExtension, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chromeExtension.c5a98b93.svg";
export { ForwardRef as ReactComponent };